import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-vitrine-footer-coriolis',
    templateUrl: './vitrine-footer-coriolis.component.html',
    styleUrls: ['./vitrine-footer-coriolis.component.css'],
    standalone: false
})
export class VitrineFooterCoriolisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
